// Resolves the "master" portal settings used by the views from the two sources:
//   1. query params on the current link (always win, and can only force a toggle on)
//   2. the application's `portal` block from golfid-api
// Anything unset resolves to false, so an app that was never configured behaves as before.
//
// Each setting keeps the query-param rule the views used before this existed so that
// existing links do not change behavior:
//   present - the param only has to exist (`?noBanner`, `?noBanner=`, `?noBanner=false` all count)
//   truthy  - the param must exist with a non-empty value
//   'true'  - the param must be exactly the string "true"
const SETTINGS = [
  { key: 'hideHeader', param: 'noHeader', rule: 'truthy' },
  { key: 'hideBanner', param: 'noBanner', rule: 'present' },
  { key: 'hideLogos', param: 'noLogos', rule: 'present' },
  { key: 'hideFooter', param: 'noFooter', rule: 'present' },
  { key: 'hideProperties', param: 'noProperties', rule: 'present' },
  { key: 'useAlternateProperties', param: null },
  { key: 'hideForgot', param: 'noForgot', rule: 'truthy' },
  { key: 'hideCreate', param: 'noCreate', rule: 'truthy' },
  { key: 'hideSelectUser', param: 'noSelectUser', rule: 'truthy' },
  { key: 'useGnButton', param: 'gnButton', rule: 'truthy' },
  { key: 'showSteps', param: 'showSteps', rule: 'true' },
  { key: 'showAppIcon', param: null }
];

const queryEnables = (query, { param, rule }) => {

  if (!param || !Object.prototype.hasOwnProperty.call(query, param)) {
    return false;
  }

  switch (rule) {
    case 'present':
      return true;
    case 'true':
      return query[param] === 'true';
    default:
      return !!query[param];
  }
};

const resolvePortalSettings = (appPortal, query) => {

  const portal = appPortal || {};
  const params = query || {};

  const resolved = SETTINGS.reduce((settings, setting) => {

    settings[setting.key] = queryEnables(params, setting) || portal[setting.key] === true;
    return settings;
  }, {});

  // hideProperties wins over useAlternateProperties.
  if (resolved.hideProperties) {
    resolved.useAlternateProperties = false;
  }

  // hideFooter has always hidden the banner too.
  if (resolved.hideFooter) {
    resolved.hideBanner = true;
  }

  return resolved;
};

export { SETTINGS };
export default resolvePortalSettings;
